import { EC_SUBMISSION_TYPES } from "../constants";

export const getRoute = (
  path: string,
  permissios: string[]
): { path: string; permissios: string[] } => ({
  path,
  permissios,
});

export const getDate = (value: string) => {
  const date = new Date(value);
  const dateArr = date.toString().split(" ");
  return `${dateArr[1]} ${dateArr[2]}, ${dateArr[3]}`;
};
export function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tab-panel-${index}`,
  };
}

export function romanize(num: number): string {
  const lookup: any = {
    m: 1000,
    cm: 900,
    d: 500,
    cd: 400,
    c: 100,
    xc: 90,
    l: 50,
    xl: 40,
    x: 10,
    ix: 9,
    v: 5,
    iv: 4,
    i: 1,
  };
  let roman = "",
    i;
  for (i in lookup) {
    while (num >= lookup[i]) {
      roman += i;
      num -= lookup[i];
    }
  }
  return roman;
}

export const getFileName = (url: any) => {
  let file = url?.split("/")?.pop();
  if (file?.includes("-")) {
    file = file.split("-").pop();
  }
  return file || "No File";
};

export const downloadFile = (url: any) => {
  if(!url){
    return;
  }
  const link = document.createElement("a");
  link.setAttribute("target", "_blank"); // Open in new tab
  link.setAttribute("rel", "noopener noreferrer");
  link.href = url;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const ecSubmissionMapping = (type: string) => {
  if (type === EC_SUBMISSION_TYPES.INITAL_REVIEW) return "Inital Review";
  if (type === EC_SUBMISSION_TYPES.ADDITIONAL_DOCUMENTS)
    return "Additional Documents";
  if (type === EC_SUBMISSION_TYPES.EC_NOTIFICATION) return "EC Notification";
  if (type === EC_SUBMISSION_TYPES.EC_ANNUAL_REPORT) return "EC Annual Report";
  if (type === EC_SUBMISSION_TYPES.PVPD_DETAILS) return "PV/PD Details";
  if (type === EC_SUBMISSION_TYPES.SAE) return "SAE";
  if (type === EC_SUBMISSION_TYPES.STUDY_CLOSEOUT_REPORT)
    return "Study Close Out Report";
};

export function getRanStr(length: number) {
  let result = "";
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function getTimeStamp() {
  const now = new Date();
  const timestamp = now.getTime();
  return timestamp;
}

export function createFileName(protocolNumber: string, docType: string) {
  return `${getTimeStamp()}-${protocolNumber}(${docType})`;
}
